import React from "react";
import { Box, Container, Typography, Link } from "@mui/material";

const scrollTo = (href) => {
  const el = document.querySelector(href);
  if (el) el.scrollIntoView({ behavior: "auto", block: "start" });
};

const testimonials = [
  {
    category: "Law Enforcement",
    quote:
      '"Gary spent 20 years protecting this community. He knows what public safety actually looks like from the inside. He has my full support."',
    name: "Active Law Enforcement Officer, Middletown",
    subtext: "",
  },
  {
    category: "Small Business",
    quote:
      '"As a small business owner in Middletown, I know Gary will listen to the real impact of regulations and taxes before casting a vote. That\'s rare."',
    name: "Local Business Owner",
    subtext: "Middletown Business Community",
  },
  {
    category: "Educators & Parents",
    quote:
      '"Gary and Michelle have navigated this school district with a child who has special needs. They understand what our families face in ways most politicians never will."',
    name: "Parent, Appoquinimink School District",
    subtext: "District 8 Resident",
  },
];

const NeighborsSpeakSection = () => {
  return (
    <Box
      className="neighbors-speak-root"
      sx={{ backgroundColor: "#FDFBF7", py: { xs: 6, md: 11 }, width: "100%" }}
    >
      <Container maxWidth="lg">
        {/* ── Header ───────────────────────────────────────────── */}
        <Box sx={{ maxWidth: "750px", mb: 8 }}>
          <Typography
            sx={{
              color: "#C59324",
              fontWeight: 700,
              letterSpacing: "0.2em",
              fontSize: "0.85rem",
              textTransform: "uppercase",
              mb: 2,
            }}
          >
            Community Endorsements
          </Typography>

          <Typography
            sx={{
              mb: "8px",
              color: "#333",
              fontWeight: 700,
              fontFamily: "'Playfair Display', serif",
              mt: 1,
              fontSize: {
                xs: "2rem",
                sm: "2.5rem",
                md: "3rem",
              },
            }}
          >
            Gary's{" "}
            <Box
              component="span"
              sx={{
                color: "#C59324",
                fontStyle: "italic",
                fontWeight: 500,
                fontFamily: "'Playfair Display', serif",
              }}
            >
              Neighbors Speak
            </Box>
          </Typography>

          <Typography
            sx={{
              color: "#5D6785",
              fontSize: "1.1rem",
              lineHeight: 1.8,
              maxWidth: "600px",
            }}
          >
            These are real Middletown residents: neighbors, community leaders,
            and professionals who have chosen to stand with Gary.
          </Typography>
        </Box>

        {/* ── Testimonial Cards ─────────────────────────────────── */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            gap: 3,
            alignItems: "stretch",
          }}
        >
          {testimonials.map((item, index) => (
            <Box
              key={index}
              sx={{
                flex: 1,
                backgroundColor: "#FFF",
                border: "1px solid rgba(0,0,0,0.06)",
                borderRadius: "8px",
                p: 4,
                display: "flex",
                flexDirection: "column",
                boxShadow: "0px 4px 20px rgba(0,0,0,0.02)",
              }}
            >
              <Typography
                sx={{
                  color: "#7B849B",
                  fontSize: "0.65rem",
                  letterSpacing: "3px",
                  textTransform: "uppercase",
                  fontWeight: 600,
                  mb: 2,
                }}
              >
                {item.category}
              </Typography>

              <Box
                sx={{
                  width: "100%",
                  height: "1px",
                  backgroundColor: "rgba(0,0,0,0.06)",
                  mb: 3,
                }}
              />

              <Typography
                sx={{
                  color: "#444",
                  fontSize: "1.05rem",
                  lineHeight: 1.9,
                  fontStyle: "italic",
                  mb: 4,
                  flex: 1,
                }}
              >
                {item.quote}
              </Typography>

              <Box>
                <Typography
                  sx={{
                    color: "#051328",
                    fontWeight: 700,
                    fontSize: "0.95rem",
                    mb: 0.5,
                  }}
                >
                  {item.name}
                </Typography>
                {item.subtext && (
                  <Typography
                    sx={{
                      color: "#C59324",
                      fontSize: "0.85rem",
                      fontWeight: 500,
                    }}
                  >
                    {item.subtext}
                  </Typography>
                )}
              </Box>
            </Box>
          ))}
        </Box>

        {/* ── CTA — "Want to endorse Gary?" → #volunteer ─────── */}
        <Box sx={{ textAlign: "center", mt: 8 }}>
          <Link
            href="#volunteer"
            onClick={(e) => {
              e.preventDefault();
              scrollTo("#volunteer");
            }}
            sx={{
              color: "#C59324",
              fontWeight: 700,
              fontSize: "1.1rem",
              textDecoration: "none",
              borderBottom: "2px solid transparent",
              transition: "all 0.3s ease",
              cursor: "pointer",
              "&:hover": {
                color: "#051328",
                borderBottom: "2px solid #C59324",
              },
            }}
          >
            Want to endorse Gary? Contact the campaign →
          </Link>
        </Box>
      </Container>
    </Box>
  );
};

export default NeighborsSpeakSection;
